import styled from "styled-components";

const VisaBannerLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.linkChevronMargin};
  margin-top: 16px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;

  img {
    display: block;
  }
`;

export default VisaBannerLink;
